import SectionActions from './SectionActions.js';

export default SectionActions;
